import { createContext, useContext, useState } from 'react';
import { localeFromPathname } from '../i18n/locales';

const LanguageContext = createContext();

// Función helper para manejar los datos de abyfoods
const getAbyfoodsData = () => {
  const data = localStorage.getItem('abyfoods-data');
  return data ? JSON.parse(data) : {};
};

const setAbyfoodsData = (newData) => {
  const currentData = getAbyfoodsData();
  const updatedData = { ...currentData, ...newData };
  localStorage.setItem('abyfoods-data', JSON.stringify(updatedData));
};

export function LanguageContextProvider({ children }) {
  // URL is the source of truth for language; localStorage only remembers a
  // preference. LocaleSync (in the router) reconciles both on every navigation.
  const initialLanguage = localeFromPathname(
    typeof window !== 'undefined' ? window.location.pathname : '/'
  );
  const [language, setLanguage] = useState(initialLanguage);

  const setNewLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    setAbyfoodsData({ language: newLanguage });
  };

  return (
    <LanguageContext.Provider value={{ language, setNewLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage should be used within LanguageContextProvider');
  }
  return context;
}
